import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  { title: "Product", links: [["Platform", "/platform"], ["Sitepar Home", "/home-product"], ["Sitepar Business", "/business"], ["Studio", "/studio"], ["Intelligence", "/intelligence"]] },
  { title: "Solutions", links: [["Homeowners", "/solutions"], ["Contractors", "/solutions"], ["Architects", "/solutions"], ["Marketplace", "/market"]] },
  { title: "Company", links: [["About", "/company"], ["Industries", "/industries"], ["Blog", "/blog"], ["Resources", "/resources"], ["Pricing", "/pricing"]] },
];

export function Footer() {
  return (
    <footer className="bg-sp-navy text-white border-t border-white/10 sp-grain" data-testid="footer">
      <div className="sp-container py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <Logo dark />
          <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
            The operating system for construction. Connecting people, projects, materials, money
            and intelligence — built for how India builds.
          </p>
          <div className="mt-5 flex gap-2 text-xs text-white/50 font-mono">
            <span className="px-2 py-1 border border-white/10 rounded">RERA-aware</span>
            <span className="px-2 py-1 border border-white/10 rounded">Made in India</span>
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <div className="sp-eyebrow mb-4">{c.title}</div>
            <ul className="space-y-2.5">
              {c.links.map(([l, to]) => (
                <li key={l}><Link to={to} className="text-sm text-white/65 hover:text-sp-orange transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="sp-container py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Sitepar. Plan. Build. Manage. Grow.</span>
          <span>Bengaluru · Mumbai · Delhi NCR · Hyderabad · Chennai · Pune</span>
        </div>
      </div>
    </footer>
  );
}
